/**
 * Providers of temperature sensor data for Cold Chain module
 *
 * @readonly
 * @enum {string}
 */
export const ColdChainApiProvider = Object.freeze({
    THERMOKING: 'THERMOKING',
    CARRIER: 'CARRIER',
    BLULOG: 'BLULOG',
    SOPAC: 'SOPAC'
})
